module.exports = __webpack_public_path__ + "img/closer.fc48c2a9.svg";